// this mutator is needed for deleteConversationItemParts
import './tryRemoveFromMailStoreItemsMutator';

import loadFolderForest from 'owa-mail-folder-forest-actions/lib/actions/loadFolderForest';
import { initializeAlwaysInCacheTableViews } from 'owa-mail-triage-local-updates/lib/actions/tableCache/alwaysInCacheTableViews';
import { loadDefaultTable } from 'owa-mail-table-loading-actions/lib/actions/loadDefaultTable';
import { initializeMailLayout } from 'owa-mail-layout';
import mailStore from 'owa-mail-store/lib/store/Store';
import conversationCache from 'owa-mail-store/lib/store/conversationCache';
import { lazyReportConversationCacheEviction } from 'owa-mail-body-compression';
import deleteConversationItemParts from 'owa-mail-store-actions/lib/actions/deleteConversationItemParts';
import { initializeOptionValues } from 'owa-outlook-service-option-store';
import { getPrimeBootSettingsOptionsValues } from 'owa-session-store';
import { loadCommandBarActions } from 'owa-mail-commandbar-actions';
import loadMailRibbonConfiguration from 'owa-mail-ribbon-store/lib/util/loadMailRibbonConfiguration';
import { initializeCommandingViewMode } from 'owa-command-ribbon-store';
import type { SessionData } from 'owa-service/lib/types/SessionData';
import { initializeSuiteHeaderPinnedPane } from 'owa-suite-header-auto-open';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import { initializeRestoreMailListener } from 'owa-freeze-dry-mail/lib/utils/handleRestoreScrollPosition';
import { initializePersistMailListener } from 'owa-freeze-dry-mail/lib/utils/handlePersistScrollPosition';
import { updateServiceConfig } from 'owa-service/lib/config';
import { getAudienceForCallsToOWS } from 'owa-service-request-config';
import { initializePstTasksOrchestrators } from 'owa-psttasks-view';
import { initializeOcpsPolicyStore } from 'owa-ocps-get-policies';
import { lazyInitializeOcpsPoliciesFromOwsPrime } from 'owa-ocps-policies-fetch';
import { initializeCopilotCommandCenter } from 'owa-copilot-command-center/lib/utils/initializeCopilotCommandCenter';
import { loadQuickSteps } from 'owa-mail-quick-steps-store/lib/util/loadQuickSteps';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import initializeShowPreviewLinesInListViewSetting from 'owa-messagelist-layout-option/lib/utils/initializeShowPreviewLinesInListViewSetting';
import initializePersonaCheckboxDisplaySetting from 'owa-messagelist-layout-option/lib/utils/initializePersonaCheckboxDisplaySetting';
import { initializeWin32StyleStore } from 'owa-theme-win32-style-store';

export default function initializeMailModuleState(sessionData?: SessionData | undefined): void {
    // Passing a delegate here as the delete callback to allow deleteConversationItemParts to be fully loaded by webpack.
    conversationCache.initialize(mailStore().conversations, key => {
        if (isGlobalFeatureEnabled('mon-mail-cold-body-compression')) {
            lazyReportConversationCacheEviction.importAndExecute(key);
        }
        deleteConversationItemParts(key);
    });

    initializePersistMailListener();
    initializeRestoreMailListener();

    const mailboxInfo = getModuleContextMailboxInfo();
    const options = getPrimeBootSettingsOptionsValues(mailboxInfo);

    initializeOptionValues(options);

    if (isGlobalFeatureEnabled('mon-win32-styling')) {
        initializeWin32StyleStore();
    }

    initializeCommandingViewMode(options, mailboxInfo);

    initializeSuiteHeaderPinnedPane(options);

    loadCommandBarActions();

    initializeAlwaysInCacheTableViews(mailboxInfo);

    loadDefaultTable(mailboxInfo, sessionData);

    loadFolderForest(sessionData);

    initializeMailLayout();

    if (isGlobalFeatureEnabled('tri-mlMultiLinePreview')) {
        void initializeShowPreviewLinesInListViewSetting();
    }

    if (isGlobalFeatureEnabled('tri-mlCheckboxBehavior-dev')) {
        void initializePersonaCheckboxDisplaySetting();
    }

    initializeOcpsPolicyStore('initializeMailModuleState');
    lazyInitializeOcpsPoliciesFromOwsPrime.importAndExecute('initializeMailModuleState');

    loadMailRibbonConfiguration();

    initializeCopilotCommandCenter(mailboxInfo);

    // Initialize PST Tasks orchestrators for handling PST account Tasks module clicks
    initializePstTasksOrchestrators();

    updateServiceConfig({ getAudienceForCallsToOWS });

    loadQuickSteps();
}
